// 📁 src/utils/matrizCorrecaoICV.js
// Mapeia cada FATOR -> lista de pares [numeroDaQuestao, alternativa]
// Alternativa sempre 'A' | 'B' | 'C'

const MATRIZ = {
  I: [
    [1,'B'], [2,'B'], [19,'C'], [20,'B'], [37,'A'], [38,'C'],
    [55,'B'], [56,'A'], [73,'C'], [74,'A'], [75,'C'],
  ],
  II: [
    [3,'B'], [4,'B'], [21,'C'], [22,'C'], [39,'A'], [40,'B'],
    [57,'A'], [58,'C'], [59,'B'], [76,'C'], [77,'B'],
  ],
  III: [
    [5,'A'], [6,'C'], [7,'A'], [23,'B'], [24,'C'], [25,'C'],
    [41,'A'], [42,'A'], [43,'B'], [60,'A'], [78,'B'],
  ],
  IV: [
    [8,'B'], [26,'B'], [44,'A'], [62,'A'], [61,'B'], [79,'B'],
    [80,'C'], [81,'C'],
  ],
  V: [
    [9,'A'], [10,'B'], [11,'B'], [27,'A'], [28,'C'], [29,'C'],
    [45,'B'], [46,'B'], [63,'B'], [64,'A'], [82,'C'],
  ],
  VI: [
    [12,'C'], [13,'B'], [30,'B'], [31,'C'], [49,'A'], [48,'A'],
    [47,'C'], [65,'C'], [66,'A'], [83,'B'], [84,'A'],
  ],
  VII: [
    [14,'A'], [32,'C'], [50,'C'], [67,'B'], [68,'A'], [85,'C'],
    [86,'A'], [87,'A'],
  ],
  VIII: [
    [15,'A'], [33,'B'], [34,'C'], [52,'A'], [51,'B'], [69,'B'],
    [70,'C'], [71,'B'],
  ],
  IX: [
    [16,'C'], [17,'B'], [18,'C'], [35,'A'], [36,'C'], [53,'B'],
    [54,'A'], [72,'A'],
  ],
  DGV: [
    [1,'B'], [2,'B'], [3,'B'], [4,'B'], [5,'A'], [6,'C'], [7,'A'],
    [8,'A'], [8,'C'], [9,'A'], [10,'B'], [11,'B'], [12,'C'], [13,'B'],
    [14,'B'], [15,'A'], [16,'C'], [17,'B'],
  ],
};

export default MATRIZ;
